import type { GameObj, OpacityComp, RotateComp, ScaleComp } from "kaplay";
import { k } from "./kaplay";

export function spin360(obj: GameObj<RotateComp>, duration = 0.6, direction = 1) {
    const start = obj.angle;
    return k.tween(0, 360 * direction, duration, (a) => (obj.angle = start + a), k.easings.easeInOutQuad);
}

export function squash(obj: GameObj<ScaleComp>, duration = 0.6) {
    return k.tween(0, 1, duration, (t) => {
        const s = Math.cos(t * Math.PI * 2);
        obj.scale = k.vec2(1, s);
    });
}

export function fadeOut(obj: GameObj<OpacityComp>, duration = 0.4) {
    return k.tween(obj.opacity, 0, duration, (o) => (obj.opacity = o));
}
